// @core/api/endpoints/product/get_my_product_profile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductProfileResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Get my profile in this product
 * Retrieves the authenticated user's profile within a specific product, including their display name, avatar, and product-specific metadata.
 */
export async function GetMyProductProfile(
  product_id: string,
  options?: RequestOptions
): Promise<ProductProfileResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/profile`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.get<ProductProfileResponse>(requestPath, { ...requestOptions });
}
